import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FinancialdetailsComponent } from './financialdetails/financialdetails.component';
import { OwnershipsummaryComponent } from './ownershipsummary/ownershipsummary.component';
import { PropertyphotosComponent } from './propertyphotos/propertyphotos.component';
import { OwnerdetailsComponent } from './ownerdetails/ownerdetails.component';
import { OwnersdocumentsComponent } from './ownersdocuments/ownersdocuments.component';
import { PropertydetailsComponent } from './propertydetails/propertydetails.component';
import { PropertyphotodetailsComponent } from './propertyphotodetails/propertyphotodetails.component';
import { PropertydocumentsComponent } from './propertydocuments/propertydocuments.component';
import { DocumentviewerComponent } from './documentviewer/documentviewer.component';
import { PinchangeComponent } from './pinchange/pinchange.component';
import { DocumentUpdateComponent } from './document-update/document-update.component';
import { OtppromptComponent } from './otpprompt/otpprompt.component';
import { LoadingProgressComponent } from './loading-progress/loading-progress.component';
import { CustomercareComponent } from './customercare/customercare.component';
import { MapviewComponent } from './mapview/mapview.component';
import { BlockcardComponent } from './blockcard/blockcard.component';
import { PropertydocumentscatComponent } from './propertydocumentscat/propertydocumentscat.component';
import {LoginGuardGuard} from "./login-guard.guard"
import { EmailProgressComponent } from './email-progress/email-progress.component';
import { SummarymailprogressComponent } from './summarymailprogress/summarymailprogress.component';
import { SummaryMessageProgressComponent } from './summary-message-progress/summary-message-progress.component';
import { Summarysheet1Component } from './summarysheet1/summarysheet1.component';
import { WhatsappProgressComponent } from './whatsapp-progress/whatsapp-progress.component';
import { PropertydocumentdetailsComponent } from './propertydocumentdetails/propertydocumentdetails.component';
import { AadhaarLoginComponent } from './aadhaar-login/aadhaar-login.component';
import { AadhaarOtpComponent } from './aadhaar-otp/aadhaar-otp.component';

const routes: Routes = [
  //{ path: '', component: LoadingProgressComponent},
  { path: '', component: LoginComponent },

  //{ path: '', component: AadhaarLoginComponent},
  //{ path: 'login', component: LoginComponent },

  //{ path: '', component: MaintenancenoticeComponent,data:{title:"under maintenance"}},
  {path:"otpprompt", component: OtppromptComponent, data:{title:"validate otp"}},
  {path:"aadhaarotp", component: AadhaarOtpComponent, data:{title:"validate otp"}},

  {path:"dashboard", component: DashboardComponent, data:{title:"dashboard"},canActivate:[LoginGuardGuard]},
  {path:"loadingprogress", component: LoadingProgressComponent, data:{title:"Loading Data"}},
  {path:"pinchange", component: PinchangeComponent, data:{title:"change pin"},canActivate:[LoginGuardGuard]},
  {path:"documentupdate", component: DocumentUpdateComponent, data:{title:"Update details"},canActivate:[LoginGuardGuard]},
  {path:"financialdetails",component: FinancialdetailsComponent, data:{title:"financial details"},canActivate:[LoginGuardGuard]},
  {path:"ownershipsummary",component: OwnershipsummaryComponent, data:{title:"owner's summary"},canActivate:[LoginGuardGuard]},
  {path:"propertyphotos", component:PropertyphotosComponent, data:{title:"property photos"},canActivate:[LoginGuardGuard]},
  {path:"ownerdetails", component:OwnerdetailsComponent, data:{title:"owner details"},canActivate:[LoginGuardGuard]},
  {path:"ownersdocuments", component:OwnersdocumentsComponent, data:{title:"owner's documents"},canActivate:[LoginGuardGuard]},
  {path:"propertydetails", component:PropertydetailsComponent, data:{title:"property details"},canActivate:[LoginGuardGuard]},
  {path:"propertyphotos", component:PropertyphotosComponent, data:{title:"property photos"},canActivate:[LoginGuardGuard]},
  {path:"propertyphotodetails", component:PropertyphotodetailsComponent, data:{title:"property photo"},canActivate:[LoginGuardGuard]},
  {path:"propertydocuments", component:PropertydocumentsComponent, data:{title:"property documents"},canActivate:[LoginGuardGuard]},
  {path:"propertydocumentscat", component:PropertydocumentscatComponent, data:{title:"property documents"},canActivate:[LoginGuardGuard]},
  {path:"documentviewer", component:DocumentviewerComponent, data:{title:"document details"},canActivate:[LoginGuardGuard]},
  {path:"customercare", component:CustomercareComponent, data:{title:"customer care"},canActivate:[LoginGuardGuard]},
  {path:"map", component:MapviewComponent, data:{title:"location on map"},canActivate:[LoginGuardGuard]},
  {path:"blockcard", component:BlockcardComponent, data:{title:"block card"},canActivate:[LoginGuardGuard]},
  {path:"mailprogress", component:EmailProgressComponent, data:{title:"send email"},canActivate:[LoginGuardGuard]},
  {path:"whatsappprogress", component:WhatsappProgressComponent, data:{title:"send message"},canActivate:[LoginGuardGuard]},
  {path:"summarymailprogress", component:SummarymailprogressComponent, data:{title:"send email"},canActivate:[LoginGuardGuard]},
  {path:"summarymessageprogress", component:SummaryMessageProgressComponent, data:{title:"send summary"},canActivate:[LoginGuardGuard]},
  {path:"summarysheet", component:Summarysheet1Component, data:{title:"Property Summary"},canActivate:[LoginGuardGuard]},
  {path:"propertydocumentdetails", component:PropertydocumentdetailsComponent, data:{title:"Document Details"},canActivate:[LoginGuardGuard]},
  
  { path: '**', component: LoginComponent, data:{title:"Login"}},
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ initialNavigation: 'enabledNonBlocking', enableTracing: false })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
